import keys from '@debbie/common/dist/cache/keys.js';
import { useMemo } from 'react';
import * as api from '../api/workflow-stages.js';
import { h } from '../index.js';
import { mapLoadable } from '../Loadable/utils.js';
import q from '../query.js';
export const workflowStagesEntity = `workflow-stages`;
const workflowStagesKey = `all-workflow-stages`;
export const useWorkflowStages = () => q.query(workflowStagesKey, api.get, keys.read.collection(workflowStagesEntity));
export const useWorkflowStagesMap = () => {
    const workflowStagesLoadable = useWorkflowStages();
    const map = useMemo(() => {
        if (!h.hasData(workflowStagesLoadable)) {
            return null;
        }
        const result = {};
        for (const stage of workflowStagesLoadable.data) {
            result[stage.id] = stage;
        }
        return result;
    }, [workflowStagesLoadable]);
    return mapLoadable(workflowStagesLoadable, map);
};
//# sourceMappingURL=index.js.map